// Variant Cards Add to Cart Handler
document.addEventListener('DOMContentLoaded', function() {
  console.log('Variant cards script loaded');
  
  // Wait for cart to be available
  function waitForCart() {
    return new Promise((resolve) => {
      if (window.cart) {
        console.log('Cart found immediately');
        resolve(window.cart);
      } else {
        console.log('Waiting for cart to be available...');
        const checkCart = () => {
          if (window.cart) {
            console.log('Cart found after waiting');
            resolve(window.cart);
          } else {
            setTimeout(checkCart, 100);
          }
        };
        checkCart();
      }
    });
  }

  // Listen for clicks on variant card buttons
  document.addEventListener('click', function(e) {
    const button = e.target.closest('[data-variant-add-to-cart][data-variant-card-id]');
    if (!button) return;
    
    console.log('Variant card button clicked:', button.dataset.variantCardId);
    
    e.preventDefault();
    e.stopPropagation();
    
    const variantId = button.dataset.variantCardId;
    const spinner = button.querySelector('[data-loading-spinner]');
    
    if (spinner) {
      spinner.classList.remove('opacity-0');
    }
    
    // Wait for cart and add the specific variant
    waitForCart().then(cart => {
      if (variantId) {
        console.log('Adding variant to cart:', variantId);
        cart.add({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        }, true).then(() => {
          console.log('Successfully added variant to cart');
          if (spinner) {
            spinner.classList.add('opacity-0');
          }
        }).catch((error) => {
          console.error('Error adding to cart:', error);
          if (spinner) {
            spinner.classList.add('opacity-0');
          }
        });
      }
    }).catch((error) => {
      console.error('Error waiting for cart:', error);
      if (spinner) {
        spinner.classList.add('opacity-0');
      }
    });
  });
}); 